var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{class:['fa', _vm.icon, 'elements__status-icon']})])}
var staticRenderFns = []

export { render, staticRenderFns }